import { Component, computed, inject, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmploymentTypeSelectInputStore } from './employment-type-select-input-store';
import { EmploymentTypeGridItemObject } from '@it2go/types';
import { getEmploymentTypesFrag } from './employment-type-select-input.query';
import { TranslateService } from '@ngx-translate/core';
import { MultiSelectInputComponent } from '../multi-select-input/multi-select-input.component';
import { SelectInputComponent } from '../select-input/select-input.component';
import { InfiniteScrollStore } from '../../../../modules/shared/store/common/infinite-scroll.store';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';

@Component({
    selector: 'app-employment-type-select-input',
    templateUrl: './employment-type-select-input.component.html',
    providers: [EmploymentTypeSelectInputStore],
    imports: [
        SelectInputComponent,
        MultiSelectInputComponent,
    ],
})
export class EmploymentTypeSelectInputComponent {

    public readonly store = inject(EmploymentTypeSelectInputStore);
    public readonly translate = inject(TranslateService);

    public form = input.required<FormGroup>();
    public multiselect = input(false);
    public disabled = input(false);
    public id = input('employmentTypeName');
    public label = input('user.common.label.employmentType');

    public typesScroll = computed(() => {
        return new InfiniteScrollStore<EmploymentTypeGridItemObject>(
            this.store.api.getEmploymentTypes,
            FilterBuilder.filter({ limit: 100 }),
            true,
            getEmploymentTypesFrag,
            (items) => {
                const types: Record<string, any> = items.reduce((acc: any, cur: EmploymentTypeGridItemObject) => {
                    const groupName = this.translate.instant(`user.common.employmentTypes.${cur.groupName}`);
                    if (!groupName) return acc;
                    if (!acc[groupName]) {
                        acc[groupName] = { name: groupName, value: cur.groupName, items: [] };
                    }
                    acc[groupName].items.push({
                        ...cur,
                        value: cur.name,
                        name: this.translate.instant(`user.common.employmentTypes.${cur.name}`),
                    });
                    return acc;
                }, {});

                return Object.values(types);
            },
        );
    });
}
